<div class="admin-tab-brand" data-testid="admin-tab-brand">
  <div class="admin-tab-brand__header">
    <h2 class="admin-tab-brand__title">My Brand</h2>
    <!--    <p class="admin-tab-brand__subtitle">Upload your logo and customize your brand to show clients your professional identity.</p>-->
  </div>
  <form [formGroup]="brandForm" class="admin-tab-brand__form" novalidate>
    <!-- Logo Upload Section -->
    <div class="form-container">
      <mat-card class="admin-tab-brand__logo-section" data-testid="logo-upload-section">
        <mat-card-header>
          <mat-card-title>Logo Upload</mat-card-title>
          <mat-card-subtitle>Supported formats: PNG, JPG, SVG (max 2MB)</mat-card-subtitle>
        </mat-card-header>

        <mat-card-content>
          <!-- Logo Preview -->
          @if (logoPreview()) {
            <div class="admin-tab-brand__preview" data-testid="logo-preview">
              <img [src]="logoPreview()" alt="Coach logo" class="admin-tab-brand__preview-image" />
              <button
                mat-icon-button
                type="button"
                class="admin-tab-brand__remove-logo"
                (click)="removeLogo()"
                data-testid="remove-logo-btn"
                aria-label="Remove logo"
                >
                <mat-icon>close</mat-icon>
              </button>
            </div>
          }

          <!-- Upload Area -->
          <div
            class="admin-tab-brand__upload-area"
            [class.admin-tab-brand__upload-area--drag-over]="isDragOver()"
            [class.admin-tab-brand__upload-area--has-logo]="logoPreview()"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)"
            data-testid="logo-upload-area"
            >
            <div class="admin-tab-brand__upload-content">
              <mat-icon class="admin-tab-brand__upload-icon">cloud_upload</mat-icon>
              <h3 class="admin-tab-brand__upload-title">Drag & Drop Your Logo</h3>
              <p class="admin-tab-brand__upload-text">or click to browse files</p>
              <input
                type="file"
                accept=".png,.jpg,.jpeg,.svg"
                (change)="onFileSelected($event)"
                class="admin-tab-brand__file-input"
                data-testid="logo-file-input"
                />
                <button mat-button type="button" class="admin-tab-brand__browse-btn" data-testid="browse-files-btn">Browse Files</button>
              </div>
            </div>

            <!-- Upload Progress -->
            @if (isUploading()) {
              <div class="admin-tab-brand__upload-progress" data-testid="upload-progress">
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                <p>Processing your logo...</p>
              </div>
            }

            <!-- Upload Error -->
            @if (uploadError()) {
              <div class="admin-tab-brand__error" data-testid="upload-error">
                <mat-icon>error</mat-icon>
                <span>{{ uploadError() }}</span>
              </div>
            }
          </mat-card-content>
        </mat-card>

        <!-- Brand Information Section -->
        <mat-card class="admin-tab-brand__info-section" data-testid="brand-info-section">
          <mat-card-header>
            <mat-card-title>Brand Information</mat-card-title>
          </mat-card-header>

          <mat-card-content>
            <div class="admin-tab-brand__form-row">
              <mat-form-field appearance="outline" class="admin-tab-brand__form-field">
                <mat-label>Brand Name *</mat-label>
                <input matInput formControlName="brandName" placeholder="Enter your brand name" data-testid="brand-name-input" />
                @if (getFieldError('brandName')) {
                  <mat-error data-testid="brand-name-error">{{ getFieldError("brandName") }}</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline" class="admin-tab-brand__form-field">
                <mat-label>Primary Color</mat-label>
                <input matInput type="color" formControlName="primaryColor" data-testid="primary-color-input" />
              </mat-form-field>
            </div>

            <mat-form-field appearance="outline" class="admin-tab-brand__form-field--full">
              <mat-label>Website</mat-label>
              <input matInput formControlName="website" placeholder="https://www.yourwebsite.com" data-testid="website-input" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="admin-tab-brand__form-field--full">
              <mat-label>Description</mat-label>
              <textarea
                matInput
                formControlName="description"
                rows="3"
                placeholder="Tell clients about your coaching approach..."
                data-testid="description-input"
              ></textarea>
            </mat-form-field>
          </mat-card-content>
        </mat-card>
      </div>
      <!-- Form Actions -->
      <div class="admin-tab-brand__actions" data-testid="brand-form-actions">
        <button
          mat-button
          type="button"
          (click)="onReset()"
          [disabled]="isSaving()"
          class="admin-tab-brand__reset-btn"
          data-testid="reset-brand-btn"
          >
          Reset
        </button>

        <button
          mat-raised-button
          color="primary"
          type="submit"
          [disabled]="isSaving() || brandForm.invalid"
          class="admin-tab-brand__save-btn"
          data-testid="save-brand-btn"
          (click)="onSave()"
          >
          @if (isSaving()) {
            <mat-icon>hourglass_empty</mat-icon>
          }
          {{ isSaving() ? "Saving..." : "Save Brand Settings" }}
        </button>
      </div>

      <!-- Save Status Messages -->
      @if (saveError() || saveSuccess()) {
        <div class="admin-tab-brand__status">
          @if (saveError()) {
            <div class="admin-tab-brand__error" data-testid="save-error">
              <mat-icon>error</mat-icon>
              <span>{{ saveError() }}</span>
            </div>
          }
          @if (saveSuccess()) {
            <div class="admin-tab-brand__success" data-testid="save-success">
              <mat-icon>check_circle</mat-icon>
              <span>Brand settings saved successfully!</span>
            </div>
          }
        </div>
      }
    </form>
  </div>
